/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var job_pb = require('./job_pb.js')

var general_pb = require('./general_pb.js')

var storage_pb = require('./storage_pb.js')
const proto = {};
proto.cloud = require('./service_ingest_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceIngestClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceIngestPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobInitRequest,
 *   !proto.cloud.JobInitResponse>}
 */
const methodDescriptor_ServiceIngest_JobInitialize = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/JobInitialize',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobInitRequest,
  proto.cloud.JobInitResponse,
  /**
   * @param {!proto.cloud.JobInitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobInitResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobInitRequest,
 *   !proto.cloud.JobInitResponse>}
 */
const methodInfo_ServiceIngest_JobInitialize = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.JobInitResponse,
  /**
   * @param {!proto.cloud.JobInitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobInitResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobInitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.JobInitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.JobInitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.jobInitialize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/JobInitialize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_JobInitialize,
      callback);
};


/**
 * @param {!proto.cloud.JobInitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.JobInitResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.jobInitialize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/JobInitialize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_JobInitialize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobUpdateRequest,
 *   !proto.cloud.JobUpdateResponse>}
 */
const methodDescriptor_ServiceIngest_JobUpdate = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/JobUpdate',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobUpdateRequest,
  proto.cloud.JobUpdateResponse,
  /**
   * @param {!proto.cloud.JobUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobUpdateRequest,
 *   !proto.cloud.JobUpdateResponse>}
 */
const methodInfo_ServiceIngest_JobUpdate = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.JobUpdateResponse,
  /**
   * @param {!proto.cloud.JobUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.JobUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.JobUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.jobUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/JobUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_JobUpdate,
      callback);
};


/**
 * @param {!proto.cloud.JobUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.JobUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.jobUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/JobUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_JobUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.TreeUpdateRequest,
 *   !proto.cloud.TreeUpdateResponse>}
 */
const methodDescriptor_ServiceIngest_FileTreeUpdate = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/FileTreeUpdate',
  grpc.web.MethodType.UNARY,
  proto.cloud.TreeUpdateRequest,
  proto.cloud.TreeUpdateResponse,
  /**
   * @param {!proto.cloud.TreeUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TreeUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.TreeUpdateRequest,
 *   !proto.cloud.TreeUpdateResponse>}
 */
const methodInfo_ServiceIngest_FileTreeUpdate = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.TreeUpdateResponse,
  /**
   * @param {!proto.cloud.TreeUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.TreeUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.TreeUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.TreeUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.TreeUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.fileTreeUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/FileTreeUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_FileTreeUpdate,
      callback);
};


/**
 * @param {!proto.cloud.TreeUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.TreeUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.fileTreeUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/FileTreeUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_FileTreeUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.MediaUpdateRequest,
 *   !proto.cloud.MediaUpdateResponse>}
 */
const methodDescriptor_ServiceIngest_MediaUpdate = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/MediaUpdate',
  grpc.web.MethodType.UNARY,
  proto.cloud.MediaUpdateRequest,
  proto.cloud.MediaUpdateResponse,
  /**
   * @param {!proto.cloud.MediaUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.MediaUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.MediaUpdateRequest,
 *   !proto.cloud.MediaUpdateResponse>}
 */
const methodInfo_ServiceIngest_MediaUpdate = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.MediaUpdateResponse,
  /**
   * @param {!proto.cloud.MediaUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.MediaUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.MediaUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.MediaUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.MediaUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.mediaUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/MediaUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_MediaUpdate,
      callback);
};


/**
 * @param {!proto.cloud.MediaUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.MediaUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.mediaUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/MediaUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_MediaUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ReportUpdateRequest,
 *   !proto.cloud.ReportUpdateResponse>}
 */
const methodDescriptor_ServiceIngest_ReportUpdate = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/ReportUpdate',
  grpc.web.MethodType.UNARY,
  proto.cloud.ReportUpdateRequest,
  proto.cloud.ReportUpdateResponse,
  /**
   * @param {!proto.cloud.ReportUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ReportUpdateResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ReportUpdateRequest,
 *   !proto.cloud.ReportUpdateResponse>}
 */
const methodInfo_ServiceIngest_ReportUpdate = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ReportUpdateResponse,
  /**
   * @param {!proto.cloud.ReportUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ReportUpdateResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ReportUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ReportUpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ReportUpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.reportUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/ReportUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_ReportUpdate,
      callback);
};


/**
 * @param {!proto.cloud.ReportUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ReportUpdateResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.reportUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/ReportUpdate',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_ReportUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.JobFinalizeRequest,
 *   !proto.cloud.JobFinalizeResponse>}
 */
const methodDescriptor_ServiceIngest_JobFinalize = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/JobFinalize',
  grpc.web.MethodType.UNARY,
  proto.cloud.JobFinalizeRequest,
  proto.cloud.JobFinalizeResponse,
  /**
   * @param {!proto.cloud.JobFinalizeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobFinalizeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.JobFinalizeRequest,
 *   !proto.cloud.JobFinalizeResponse>}
 */
const methodInfo_ServiceIngest_JobFinalize = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.JobFinalizeResponse,
  /**
   * @param {!proto.cloud.JobFinalizeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.JobFinalizeResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.JobFinalizeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.JobFinalizeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.JobFinalizeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.jobFinalize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/JobFinalize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_JobFinalize,
      callback);
};


/**
 * @param {!proto.cloud.JobFinalizeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.JobFinalizeResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.jobFinalize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/JobFinalize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_JobFinalize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EntitiesUploadInitializeRequest,
 *   !proto.cloud.EntitiesUploadInitializeResponse>}
 */
const methodDescriptor_ServiceIngest_EntitiesUploadInitialize = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/EntitiesUploadInitialize',
  grpc.web.MethodType.UNARY,
  proto.cloud.EntitiesUploadInitializeRequest,
  proto.cloud.EntitiesUploadInitializeResponse,
  /**
   * @param {!proto.cloud.EntitiesUploadInitializeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntitiesUploadInitializeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EntitiesUploadInitializeRequest,
 *   !proto.cloud.EntitiesUploadInitializeResponse>}
 */
const methodInfo_ServiceIngest_EntitiesUploadInitialize = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.EntitiesUploadInitializeResponse,
  /**
   * @param {!proto.cloud.EntitiesUploadInitializeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntitiesUploadInitializeResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EntitiesUploadInitializeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.EntitiesUploadInitializeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.EntitiesUploadInitializeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.entitiesUploadInitialize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/EntitiesUploadInitialize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_EntitiesUploadInitialize,
      callback);
};


/**
 * @param {!proto.cloud.EntitiesUploadInitializeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.EntitiesUploadInitializeResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.entitiesUploadInitialize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/EntitiesUploadInitialize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_EntitiesUploadInitialize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EntitiesUploadFinalizeRequest,
 *   !proto.cloud.EntitiesUploadFinalizeResponse>}
 */
const methodDescriptor_ServiceIngest_EntitiesUploadFinalize = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/EntitiesUploadFinalize',
  grpc.web.MethodType.UNARY,
  proto.cloud.EntitiesUploadFinalizeRequest,
  proto.cloud.EntitiesUploadFinalizeResponse,
  /**
   * @param {!proto.cloud.EntitiesUploadFinalizeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntitiesUploadFinalizeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EntitiesUploadFinalizeRequest,
 *   !proto.cloud.EntitiesUploadFinalizeResponse>}
 */
const methodInfo_ServiceIngest_EntitiesUploadFinalize = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.EntitiesUploadFinalizeResponse,
  /**
   * @param {!proto.cloud.EntitiesUploadFinalizeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EntitiesUploadFinalizeResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EntitiesUploadFinalizeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.EntitiesUploadFinalizeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.EntitiesUploadFinalizeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.entitiesUploadFinalize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/EntitiesUploadFinalize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_EntitiesUploadFinalize,
      callback);
};


/**
 * @param {!proto.cloud.EntitiesUploadFinalizeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.EntitiesUploadFinalizeResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.entitiesUploadFinalize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/EntitiesUploadFinalize',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_EntitiesUploadFinalize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.CreateManifestRequest,
 *   !proto.cloud.CreateManifestResponse>}
 */
const methodDescriptor_ServiceIngest_CreateManifest = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/CreateManifest',
  grpc.web.MethodType.UNARY,
  proto.cloud.CreateManifestRequest,
  proto.cloud.CreateManifestResponse,
  /**
   * @param {!proto.cloud.CreateManifestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CreateManifestResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.CreateManifestRequest,
 *   !proto.cloud.CreateManifestResponse>}
 */
const methodInfo_ServiceIngest_CreateManifest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.CreateManifestResponse,
  /**
   * @param {!proto.cloud.CreateManifestRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CreateManifestResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.CreateManifestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.CreateManifestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.CreateManifestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.createManifest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/CreateManifest',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_CreateManifest,
      callback);
};


/**
 * @param {!proto.cloud.CreateManifestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.CreateManifestResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.createManifest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/CreateManifest',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_CreateManifest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.CreateReportRequest,
 *   !proto.cloud.CreateReportResponse>}
 */
const methodDescriptor_ServiceIngest_CreateReport = new grpc.web.MethodDescriptor(
  '/cloud.ServiceIngest/CreateReport',
  grpc.web.MethodType.UNARY,
  proto.cloud.CreateReportRequest,
  proto.cloud.CreateReportResponse,
  /**
   * @param {!proto.cloud.CreateReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CreateReportResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.CreateReportRequest,
 *   !proto.cloud.CreateReportResponse>}
 */
const methodInfo_ServiceIngest_CreateReport = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.CreateReportResponse,
  /**
   * @param {!proto.cloud.CreateReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.CreateReportResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.CreateReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.CreateReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.CreateReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceIngestClient.prototype.createReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceIngest/CreateReport',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_CreateReport,
      callback);
};


/**
 * @param {!proto.cloud.CreateReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.CreateReportResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceIngestPromiseClient.prototype.createReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceIngest/CreateReport',
      request,
      metadata || {},
      methodDescriptor_ServiceIngest_CreateReport);
};


module.exports = proto.cloud;

